import { filterFields, routeOrgScoped } from './catalog'

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

// Operators in words, for the filter dropdown and the summaries.
export const OP_WORDS = { equals: 'is', not_equals: 'is not', contains: 'contains', not_contains: "doesn't contain", in: 'is one of', not_in: 'is not one of', gte: 'at least', lte: 'at most', exists: 'is set' }

// The word for one alert of a category: "Every error alert", "All SSO
// alerts". The catalog's alertNoun wins when the server sends one; the four
// seeded categories (spec §13.1) have their word here until it does.
const NOUNS = { errors: 'error', sso: 'SSO', support: 'support', contact: 'contact form' }
export const categoryNoun = (key, catalog) => {
  const cat = catalog && (catalog.categories || []).find(c => c.key === key)
  if (cat && cat.alertNoun) return cat.alertNoun
  if (NOUNS[key]) return NOUNS[key]
  return cat && cat.label ? cat.label.toLowerCase() : key
}

// A category-wide route never covers a platform-only alert (catalog.js
// coversTrigger): a platform route's summary names what it leaves out.
// In parts, for the routes list: `items`, each alert the route picks or its
// one category-wide set ("All SSO alerts"), and `except`, what that set
// leaves out (the list shows "except 1", which opens them; owner 2026-11-02).
export const triggerParts = (route, catalog) => {
  if (!route.triggerKinds || route.triggerKinds.length === 0) {
    const left = routeOrgScoped(route) ? [] : (catalog.triggers || []).filter(t => t.category === route.category && t.platformOnly)
    return { items: [`All ${categoryNoun(route.category, catalog)} alerts`], except: left.map(t => t.label) }
  }
  return { items: route.triggerKinds.map(k => (catalog.triggers.find(t => t.kind === k) || { label: k }).label), except: [] }
}
// In words: each alert, or the set and what it leaves out in one sentence
// ("All SSO alerts except Staff sign-in method").
export const triggerSummary = (route, catalog) => {
  const { items, except } = triggerParts(route, catalog)
  return except.length ? `${items[0]} except ${except.join(', ')}` : items.join(', ')
}

// A route's severity floor in words, for the editor's dropdown and the summaries.
export const SEVERITY_FLOOR = { info: 'Any severity', warning: 'Warning or critical', critical: 'Critical only' }

// A filter's field by the catalog's label, else its key in words; never the
// raw key (owner 2026-11-02: the list showed "severity ≥ warning").
const fieldLabel = (route, key, catalog) => {
  const field = catalog ? filterFields(route, catalog).find(f => f.key === key) : null
  return field && field.label ? field.label : String(key).replace(/[_.]+/g, ' ')
}
const sentence = s => s.charAt(0).toUpperCase() + s.slice(1)

export const filterItems = (route, catalog) => {
  const parts = (route.filters || []).map(f => sentence(`${fieldLabel(route, f.field, catalog)} ${OP_WORDS[f.op] || f.op} ${Array.isArray(f.value) ? f.value.join(', ') : f.op === 'exists' ? '' : f.value}`.trim()))
  if (route.minSeverity && route.minSeverity !== 'info') parts.push(SEVERITY_FLOOR[route.minSeverity] || route.minSeverity)
  return parts
}
export const NO_FILTERS = 'No filters'
export const filterSummary = (route, catalog) => filterItems(route, catalog).join(' · ') || NO_FILTERS

const dayWords = days => {
  if (!days || days.length === 0 || days.length === 7) return 'Every day'
  const set = [...days].sort((a, b) => DAYS.indexOf(a) - DAYS.indexOf(b)).join(',')
  if (set === 'mon,tue,wed,thu,fri') return 'Weekdays'
  if (set === 'sat,sun') return 'Weekends'
  return days.map(d => d[0].toUpperCase() + d.slice(1)).join(', ')
}

export const whenItems = route => {
  const s = route.schedule
  const when = s ? `${dayWords(s.days)} ${s.from}–${s.to} ${s.timezone}` : 'Any time'
  const delivery = route.deliveryMode === 'digest' ? `digest ${route.digestMinutes} min` : 'send now'
  return [when, delivery]
}
export const whenSummary = route => whenItems(route).join(' · ')
